import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, Text, useTheme } from "native-base";
import { useMemo } from "react";
import { formatDate } from "@madmedical/utils";
import { serviceForHumans } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../providers/routing";
import ReactTable from "../molecules/ReactTable";
import Tooltip from "../atoms/Tooltip";
import Icon from "../icons/Icon";
import Tag from "../atoms/Tag";
import AvatarTexts from "../molecules/AvatarTexts";
import { usePatients } from "../providers/patient";
const DoctorPatientsTable = ({ onEndReached }) => {
    const { colors } = useTheme();
    const { patients, onSortChange } = usePatients();
    const navigate = useRouteNavigate();
    const { t } = useTranslation();
    const handleRowPress = ({ userId }) => {
        navigate("patient", { patientId: userId });
    };
    const columns = useMemo(() => [
        {
            Header: t("patientName"),
            accessor: "fullName",
            defaultCanSort: !!onSortChange,
            width: "20%",
            Cell: ({ row }) => {
                const { fullName, initials, avatarUrl } = row.original;
                return (_jsx(AvatarTexts, { initials: initials, label: fullName, source: avatarUrl }));
            },
        },
        {
            accessor: "services",
            disableSortBy: true,
            width: "auto",
            Header: () => (_jsxs(HStack, Object.assign({ alignItems: "center" }, { children: [_jsx(Text, Object.assign({ color: "gray.600" }, { children: t("package") })), _jsx(Tooltip, Object.assign({ hasArrow: true, label: t("doctor:packageLabelDescription"), placement: "right" }, { children: _jsx(Box, Object.assign({ ml: 2 }, { children: _jsx(Icon, { name: "help", size: 14, fill: colors.gray[600] }) })) }))] }))),
            Cell: ({ value: services }) => (_jsx(HStack, Object.assign({ space: 1 }, { children: services.map((service) => (_jsx(Tag, { children: serviceForHumans(service) }, service))) }))),
        },
        {
            Header: t("socialSecurityNumber"),
            accessor: "socialSecurityNumber",
            disableSortBy: true,
            width: "15%",
            Cell: ({ value: socialSecurityNumber }) => (_jsx(_Fragment, { children: socialSecurityNumber !== null && socialSecurityNumber !== void 0 ? socialSecurityNumber : "-" })),
        },
        {
            Header: t("dateOfBirth"),
            accessor: "birthDate",
            defaultCanSort: !!onSortChange,
            width: "10%",
            Cell: ({ value: birthDate }) => (_jsx(_Fragment, { children: birthDate ? formatDate(birthDate) : "-" })),
        },
    ], [colors, onSortChange, t]);
    return (_jsx(ReactTable, { columns: columns, data: patients, onSortChange: onSortChange, onEndReached: onEndReached, onPress: handleRowPress }));
};
export default DoctorPatientsTable;
